import { render, staticRenderFns } from "./MembershipRequests.vue?vue&type=template&id=e25bc90e&"
import script from "./MembershipRequests.vue?vue&type=script&lang=js&"
export * from "./MembershipRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports